import {
  AuthTitle,
  SocialBtn,
  SocialBtnWrap,
  Text,
} from 'components/AuthorizationForm/AuthorizationSocial/AuthorizationSocial.styled';
import { useTranslation } from 'react-i18next';
import google from 'images/google.svg';
import { googleAuthService } from '../../../services/googleAuthService';
import { appleAuthService } from '../../../services/appleAuthService';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AuthSocial = ({ isLogin = true }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    // Слушаем событие успешной авторизации через Google
    const handleGoogleAuthSuccess = () => {
      // Перенаправляем на главную страницу после успешной авторизации
      setTimeout(() => {
        navigate('/home', { replace: true });
      }, 500);
    };

    // Слушаем событие успешной авторизации через Apple
    const handleAppleAuthSuccess = () => {
      // Перенаправляем на главную страницу после успешной авторизации
      setTimeout(() => {
        navigate('/home', { replace: true });
      }, 500);
    };

    window.addEventListener('googleAuthSuccess', handleGoogleAuthSuccess);
    window.addEventListener('appleAuthSuccess', handleAppleAuthSuccess);

    return () => {
      window.removeEventListener('googleAuthSuccess', handleGoogleAuthSuccess);
      window.removeEventListener('appleAuthSuccess', handleAppleAuthSuccess);
    };
  }, [navigate]);

  const handleGoogleClick = async (e) => {
    e.preventDefault();
    try {
      if (isLogin) {
        await googleAuthService.signIn();
      } else {
        await googleAuthService.signUp();
      }
    } catch (error) {
      console.error('Google auth error:', error);
    }
  };

  const handleAppleClick = async (e) => {
    e.preventDefault();
    try {
      if (isLogin) {
        await appleAuthService.signIn();
      } else {
        await appleAuthService.signUp();
      }
    } catch (error) {
      console.error('Apple auth error:', error);
    }
  };

  return (
    <div>
      <AuthTitle>{t('authForm.descGoogleAuth')}:</AuthTitle>
      <SocialBtnWrap>
        <SocialBtn onClick={handleGoogleClick} as="button" type="button">
          <img
            src={google}
            alt="google icon"
            style={{ width: '20px', height: '20px', marginRight: '10px' }}
          />
          <Text>Google</Text>
        </SocialBtn>
        <SocialBtn onClick={handleAppleClick} as="button" type="button">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="currentColor"
            style={{ marginRight: '10px' }}
          >
            <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
          </svg>
          <Text>Apple</Text>
        </SocialBtn>
      </SocialBtnWrap>
    </div>
  );
};
